(function () {
  'use strict';

  angular
    .module('admin.ambassador_giveaway.service', [])
    .factory('AmbassadorGiveawayService', AmbassadorGiveawayService);

  /** @ngInject */
  function AmbassadorGiveawayService($http, $q, API) {

    function list(start, limit) {
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/ambassadors/print_escrows?start=' + start + '&limit=' + limit)
        .success(defered.resolve);

      return defered.promise;
    }

    function listTransfer(start, limit) {
      var defered = $q.defer();

      $http.get(API.API_URL + 'ambassador/print_transfer_logs?start=' + start + '&limit=' + limit)
        .success(defered.resolve);

      return defered.promise;
    }

    return {
      list: list,
      listTransfer: listTransfer,
    };

  }

})();
